import { render, staticRenderFns } from "./PickupSelect.vue?vue&type=template&id=6e54f580&scoped=true&"
import script from "./PickupSelect.vue?vue&type=script&lang=ts&"
export * from "./PickupSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PickupSelect.vue?vue&type=style&index=0&id=6e54f580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54f580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDialog,VIcon,VMenu})
